// Shorten text.
export default function (filter, filterData = null) {
  let filterDataContainer = []
  // Does the filter have its data
  if (filter.filterData) filterDataContainer = filter.filterData
  // Or are we passing it.
  if (filterData) filterDataContainer = filterData
  //if (!filter.filterData) return 'Filter data incomplete'
  if (typeof filterDataContainer === 'string') return filter.selected
  const valueName = filterDataContainer.filter((fv) => fv.id == filter.selected)
  return valueName[0] ? valueName[0].name : filter.selected
}
